import script from "./AssetByTicker.vue?vue&type=script&setup=true&lang=js"
export * from "./AssetByTicker.vue?vue&type=script&setup=true&lang=js"

import "./AssetByTicker.vue?vue&type=style&index=0&id=479b2b99&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-479b2b99"]])

export default __exports__